// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1535":"09ea62c1","3922":"b6df15c6","4636":"8276c0f8"}[chunkId] + ".chunk.css";
};